import React from "react";
import PropTypes from "prop-types";
import TransactionExpense from "./TransactionExpense";
import TransactionIncome from "./TransactionIncome";
import TransactionTransfer from "./TransactionTransfer";
import ChangeBudget from "./ChangeBudget";
import ChangeBalance from "./ChangeBalance";

const Transaction = ({ transaction, onClick }) => {
    const type = transaction.type;
    const common = { transaction, onClick };

    switch (type) {
        case "EXPENSE":
            return <TransactionExpense {...common} />;
        case "INCOME":
            return <TransactionIncome {...common} />;
        case "TRANSFER":
            return <TransactionTransfer {...common} />;
        case "BUDGET":
            return <ChangeBudget {...common} />;
        case "SET_BALANCE":
            return <ChangeBalance {...common} />;
        default:
            return "";
    }
};

Transaction.propTypes = {
    transaction: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        type: PropTypes.string.isRequired,
        description: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default Transaction;
